class WidgetsApi {
    async setPreferences(admin_id, preferences) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/widget-preferences/save/`
        const values = {
            "admin_id": admin_id,
            "preferences": preferences
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    }

    async getAdminPreferences(admin_id) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/widget-preferences/get/`
        const values = {
            "admin_id": admin_id
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    };

    async getWidgets() {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/widgets/`;
        const tenant=globalThis.localStorage.getItem('tenant');
        const accessToken = localStorage.getItem(`accessToken_${tenant}`);
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.msg || 'Failed to fetch widgets');
        }
        return response.json();
    }

   
    

    async getFinishedEpp() {
        const tenant = globalThis.localStorage.getItem('tenant');
        const response = await fetch(`${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_finished_epp/`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem(`accessToken_${tenant}`)}` }, body: '{}',
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).msg || 'Failed to fetch finished EPPs');
        return response.json();
    }

    async getBestFinishedEpp() {
        const tenant = globalThis.localStorage.getItem('tenant');
        const response = await fetch(`${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/best_finished_epp/`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem(`accessToken_${tenant}`)}` }, body: '{}',
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).msg || 'Failed to fetch best EPPs');
        return response.json();
    }
    async  getWidgetLocations(admin_id) {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/widgets/localisations/${admin_id}/`;
    const tenant=globalThis.localStorage.getItem('tenant');
        const accessToken = localStorage.getItem(`accessToken_${tenant}`);
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.msg || 'Failed to fetch widget locations');
    }

    return response.json();
}

async deleteAllWidgetLocalisations() {
    const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/widget-localisations/delete-all/`;
    const tenant=globalThis.localStorage.getItem('tenant');
        const accessToken = localStorage.getItem(`accessToken_${tenant}`);
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.msg || 'Failed to delete widget localisations');
        }

        return await response.json();
    } catch (error) {
        console.error('Error deleting widget localisations:', error);
        throw error;
    }
}


    async getInProgressEpp() {
        const tenant = globalThis.localStorage.getItem('tenant');
        const response = await fetch(`${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_in_progress_epp/`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem(`accessToken_${tenant}`)}` }, body: '{}',
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).msg || 'Failed to fetch in-progress EPPs');
        return response.json();
    }

    async  createWidgetLocation(admin_id, zone) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/widget-locations/create/`;
        const values = {
            "admin_id": admin_id,
            "zone": zone
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const resp = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return Promise.resolve(json);
    }
    
    
    async getUniqueParticipants(querystring = '') {
        const tenant = globalThis.localStorage.getItem('tenant');
        const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_unique_participants/`;
        const accessToken = localStorage.getItem(`accessToken_${tenant}`);
        // Extraire year depuis querystring pour l'envoyer en POST body
        const year = new URLSearchParams(querystring).get('year') || null;
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify(year ? { year } : {}),
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.msg || 'Failed to fetch unique participants');
        }
        return response.json();
    }

    async getGlobalSatisfaction(querystring = '') {
        const tenant = globalThis.localStorage.getItem('tenant');
        const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_global_satisfaction/`;
        const accessToken = localStorage.getItem(`accessToken_${tenant}`);
        // Extraire year depuis querystring pour l'envoyer en POST body
        const year = new URLSearchParams(querystring).get('year') || null;
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify(year ? { year } : {}),
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(error.msg || 'Failed to fetch global satisfaction');
        }
        return response.json();
    }
    

    async getTopAuditSatisfaction() {
        const tenant = globalThis.localStorage.getItem('tenant');
        const response = await fetch(`${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_best_satisfaction_scores/`, {
            method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem(`accessToken_${tenant}`)}` }, body: '{}',
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).msg || 'Failed to fetch top satisfaction scores');
        return response.json();
    }
    

    async getSatisfactionQuestionnaireList(admin_id) {
        const tenant = globalThis.localStorage.getItem('tenant');
        const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/survey/getAll/`;
        const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({ admin_id }),
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        });
        const data = await response.json();
        // L'endpoint retourne soit un tableau soit {"msg": "..."}
        if (Array.isArray(data)) return data;
        throw new Error(data.msg || `HTTP ${response.status}`);
    }

    async getSatisfactionQuestionnaireDates(survey_id) {
        const tenant = globalThis.localStorage.getItem('tenant');
        const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_satisfaction_questionnaire_dates/`;
        const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
        const response = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({ survey_id }),
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
        });
        if (!response.ok) {
            let msg = `HTTP ${response.status}`;
            try { const e = await response.json(); msg = e.msg || e.error || msg; } catch {}
            throw new Error(msg);
        }
        return response.json();
    }

    async getSatisfactionDetails(querystring = '') {
        const tenant = globalThis.localStorage.getItem('tenant');
        const url = `${process.env.REACT_APP_BACK}/subdomain/${tenant}/api/get_satisfaction_details/`;
        const accessToken = localStorage.getItem(`accessToken_${tenant}`);
        // Extraire les params depuis querystring pour les envoyer en POST body
        const params = Object.fromEntries(new URLSearchParams(querystring));
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify(params),
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).msg || 'Failed to fetch satisfaction details');
        return response.json();
    }

    async saveWidgetLocations(admin_id, widgets) {
        const url = `${process.env.REACT_APP_BACK}/subdomain/${globalThis.localStorage.getItem('tenant')}/api/savelocation/send/`;
        const values = {
          admin_id, // Ajouter admin_id
          widgets,
        };
        const tenant=globalThis.localStorage.getItem('tenant');
    const accessToken = globalThis.localStorage.getItem(`accessToken_${tenant}`);
      
        try {
          const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify(values),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          });
      
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
      
          return await response.json();
        } catch (error) {
          console.error("Error saving widget locations:", error);
          throw error;
        }
      }
      
    
}

export const widgetsApi = new WidgetsApi();